import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizensServicesSector} from './citizens-services-sector.model';
import * as CitizensServicesSectorActions from './citizens-services-sector.actions';

export const citizensServicesSectorsFeatureKey = 'citizensServicesSectors';

export interface State extends EntityState<CitizensServicesSector> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizensServicesSector> = createEntityAdapter<CitizensServicesSector>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensServicesSectorActions.addCitizensServicesSector,
    (state, action) => adapter.addOne(action.citizensServicesSector, state)
  ),
  on(CitizensServicesSectorActions.upsertCitizensServicesSector,
    (state, action) => adapter.upsertOne(action.citizensServicesSector, state)
  ),
  on(CitizensServicesSectorActions.addCitizensServicesSectors,
    (state, action) => adapter.addMany(action.citizensServicesSectors, state)
  ),
  on(CitizensServicesSectorActions.upsertCitizensServicesSectors,
    (state, action) => adapter.upsertMany(action.citizensServicesSectors, state)
  ),
  on(CitizensServicesSectorActions.updateCitizensServicesSector,
    (state, action) => adapter.updateOne(action.citizensServicesSector, state)
  ),
  on(CitizensServicesSectorActions.updateCitizensServicesSectors,
    (state, action) => adapter.updateMany(action.citizensServicesSectors, state)
  ),
  on(CitizensServicesSectorActions.deleteCitizensServicesSector,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensServicesSectorActions.deleteCitizensServicesSectors,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensServicesSectorActions.loadCitizensServicesSectors,
    (state, action) => adapter.setAll(action.citizensServicesSectors, state)
  ),
  on(CitizensServicesSectorActions.clearCitizensServicesSectors,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
